






























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AccountInfo } from "@azure/msal-browser";

import CookieDialog from "@/components/Cookies/CookieDialog.vue";
import SubscriptionPopup from "@/components/Account/SubscriptionPopup.vue";

@Component({
  components: {
    CookieDialog,
    SubscriptionPopup
  }
})
export default class AccountToolbarItem extends Vue {
  public subscriptionPopupOpened = false;
  public cookieSettingsOpened = false;

  // Getter:
  public get userAccount(): AccountInfo | null {
    return this.$store.state.userAccount;
  }

}
